import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Popup } from 'react-leaflet';
import { SignalGroup } from "../../deviceState/SignalGroup";
import {
    getCongestion,
    getDeviceState,
    getQueueLength,
    getTrafficAmount, setCongestion,
    setDeviceState, setQueueLength,
    setTrafficAmount
} from "../../deviceState/deviceStateSlice";
import { setActiveLight } from "../mapSlice";
import { TrafficStatistics } from "../../deviceState/TrafficStatistics";
import Collapsible from "../../ui/Collapsible";
import { IntersectionInfo } from "../../deviceState/IntersectionInfo";

const TrafficLightMarkerPopup = (props) => {
    const { id, properties } = props.data;
    const dispatch = useDispatch();
    const deviceId = properties['liva_nro'];
    const [timerId, setTimerId] = useState(-1);

    const handleOnOpen = () => {
        dispatch(setActiveLight(properties));
        handleDeviceStateFetch(deviceId);
        handleTrafficAmountFetch(deviceId);
        handleQueueLengthFetch(deviceId);
        handleCongestionFetch(deviceId);
        setTimerId(setInterval(() => handleDeviceStateFetch(deviceId), 1000));
        console.log('intersection:', id, deviceId);
        window.location.hash = deviceId;
    };
    const handleOnClose = () => {
        clearInterval(timerId);
        dispatch(setDeviceState({}));
        dispatch(setTrafficAmount({}));
        dispatch(setQueueLength({}));
        dispatch(setCongestion({}));
        dispatch(setActiveLight(null));
        window.location.hash = '';
    };

    const handleDeviceStateFetch = (deviceId) => {
        dispatch(getDeviceState(deviceId));
    };

    const handleTrafficAmountFetch = (deviceId) => {
        dispatch(getTrafficAmount(deviceId));
    };

    const handleQueueLengthFetch = (deviceId) => {
        dispatch(getQueueLength(deviceId));
    };

    const handleCongestionFetch = (deviceId) => {
        dispatch(getCongestion(deviceId));
    };

    const { t } = useTranslation();

    return (
        <Popup eventHandlers={{ add: handleOnOpen, remove: handleOnClose }}>
            <SignalGroup intersection={properties} />
            <Collapsible label={t('popup.statistics')}>
                <TrafficStatistics />
            </Collapsible>
            <Collapsible label={t('popup.intersection_info')}>
                <IntersectionInfo intersection={properties} />
            </Collapsible>
        </Popup>
    );
};

export default TrafficLightMarkerPopup;
